import { Injectable } from '@angular/core';
import { IAMApiService, ResendPartnerAdminWelcomeEmailRequestInterface } from '@vendasta/partner';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WelcomeEmailService {
  constructor(private iamApiService: IAMApiService) {}

  resendPartnerAdminWelcomeEmail(
    partnerID: string,
    userID: string,
    usePlatformDefaultDomain?: boolean,
  ): Observable<HttpResponse<null>> {
    const req = {
      partnerId: partnerID,
      userId: userID,
      usePlatformDefaultDomain: usePlatformDefaultDomain || false,
    } as ResendPartnerAdminWelcomeEmailRequestInterface;
    return this.iamApiService.resendPartnerAdminWelcomeEmail(req);
  }
}
